import { zPersonSearchData } from "src/types/ZPersonSearchData";
import { ZUid } from "src/types/zUid";
import { apiAdminUrl } from "./apiUrl";
import { rest } from "./rest";

type ParamsLoadPersonList = {
  roleIds: ZUid[];
  objectId: ZUid;
  userIds?: ZUid[];
};

export const apiLoadPersonList = async (
  params: ParamsLoadPersonList,
  query?: unknown,
) => {
  const { roleIds, userIds, objectId } = params;
  const body = { roleIds, userIds };
  const resp = await rest.post(
    apiAdminUrl(`/objects/${objectId}/users/list`),
    body,
    {
      params: query,
    },
  );
  const searchData = zPersonSearchData.parse(resp.data);
  return searchData;
};
